import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  dashboard: [],
  loading: false,
  error: null,
};

export const dataAnalyticsDashboardSelector = (state) => state.dataAnalytics.dashboard;
export const dataAnalyticsLoadingSelector = (state) => state.dataAnalytics.loading;
export const dataAnalyticsErrorSelector = (state) => state.dataAnalytics.error;

export const fetchDataAnalyticsDashboard = createAsyncThunk("dataAnalytics/fetchDashboard", async ({ startDate, endDate, empresasIds, acessoId, modulosIds }, thunkAPI) => {
  try {
    const res = await axios.get("/dataAnalytics/dashboard", { params: { startDate, endDate, empresasIds, acessoId, modulosIds } });
    return res.data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

const dataAnalyticsSlice = createSlice({
  name: "dataAnalytics",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataAnalyticsDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDataAnalyticsDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboard = action.payload;
      })
      .addCase(fetchDataAnalyticsDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default dataAnalyticsSlice.reducer;
